import { useLayoutEffect, useRef, type RefObject } from "react";
import { playDirectionalEnter } from "@acto/taskpane/field-sales-2/utils/viewTransitions";

/**
 * Replays the shared directional enter animation on `ref` when `periodTime`
 * changes: a later period reads as "push", an earlier one as "pop". No animation
 * on first mount or when the period is unchanged.
 */
export function useDirectionalShift(ref: RefObject<HTMLElement | null>, periodTime: number): void {
  const previous = useRef<number | null>(null);

  useLayoutEffect(() => {
    const from = previous.current;
    previous.current = periodTime;
    if (from === null || from === periodTime || !ref.current) return;

    playDirectionalEnter(ref.current, periodTime > from ? "push" : "pop");
  }, [ref, periodTime]);
}
